import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["title", "recurrence", "when"];
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import CalendarPopover from "./calendar-popover.vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import momentPlugin from "@fullcalendar/moment";
import momentTZPlugin from "@fullcalendar/moment-timezone";
import rrulePlugin from "@fullcalendar/rrule";
import listPlugin from "@fullcalendar/list";
import CalendarMissingAsset from "@Shared/@Assets/img/calendar-missing.png";
import { mapGetters, mapActions } from "vuex";
import { CURRENT_ACCOUNT_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { getCalendarEvents } from "../api/dashboard-api";
import { GET_SYNCED_EMAILS } from "../../settings/store/settings-getters";
import { LOAD_SYNCED_EMAILS, REFRESH_TOKEN_NYLAS, UPDATE_REFRESH_TOKEN } from "../../settings/store/settings-actions";
import CalendarLoader from "./loaders/calendar-loader.vue";
import ScheduleModal from "@Broker/@Modules/dashboard/components/schedule-modal.vue";
import frLocale from "@fullcalendar/core/locales/fr";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import Err from "@Broker/@Routes/error";
import MeetingsModal from "./meetings-modal.vue";
import { NYLAS_CLIENT_ID } from "@Shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DashboardCalendar",
  components: {
    FullCalendar,
    MeetingsModal,
    CalendarPopover,
    CalendarLoader,
    ScheduleModal,
    InlineLoader
  },
  data() {
    return {
      refreshingEvents: true,
      loadingCalendarEvent: false,
      loading: true,
      emailConnected: false,
      fetchedEvents: [],
      fetchedDate: "",
      eventObj: {},
      eventInfo: {},
      showCalendarPopover: false,
      frLocale,
      shouldDisplayScheduler: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_DETAILS])), mapGetters("SettingsStore", [GET_SYNCED_EMAILS])), {}, {
    tooltipMarkup() {
      return `
        <p class="font-sm mb-0">
          <span class="bold">${this.$t("settings.accountTab.googleApiMessage.1")}:</span> ${this.$t("settings.accountTab.googleApiMessage.2")} <a
            href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
            rel="noopener noreferrer"
            target="_blank"
          >${this.$t("settings.accountTab.googleApiMessage.3")}</a>, ${this.$t("settings.accountTab.googleApiMessage.4")}
        </p>
      `;
    },
    userTimezone() {
      return this.CURRENT_ACCOUNT_DETAILS.timezone;
    },
    syncedEmail() {
      return this.GET_SYNCED_EMAILS;
    },
    noCalendarImg() {
      return CalendarMissingAsset;
    },
    calendarOptions() {
      return {
        height: "100%",
        initialView: "timeGridWeek",
        weekends: true,
        timeZone: this.userTimezone,
        events: this.getEventData,
        eventDataTransform: this.transformEvent,
        locale: this.locale,
        locales: {
          frLocale: this.frLocale
        },
        eventClick: this.triggerPopover,
        plugins: [bootstrapPlugin, dayGridPlugin, timeGridPlugin, rrulePlugin, listPlugin, momentPlugin, momentTZPlugin],
        themeSystem: "bootstrap",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "meetings dayGridMonth,timeGridWeek,timeGridDay,listWeek"
        },
        viewDidMount: view => {
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = this.$t("dashboard.calendar.allDay");
          const el = document.getElementsByClassName("fc-timegrid-axis-frame");
          el[0].setAttribute("class", "fc-timegrid-axis-frame d-none");
        },
        buttonText: {
          dayGridMonth: this.$t("dashboard.calendar.month"),
          timeGridWeek: this.$t("dashboard.calendar.week"),
          timeGridDay: this.$t("dashboard.calendar.day"),
          listWeek: this.$t("dashboard.calendar.weekList"),
          today: this.$t("dashboard.calendar.today")
        },
        customButtons: {
          meetings: {
            text: this.$tc("global.words.meeting", 2),
            click: this.meetingClick
          }
        },
        views: {
          dayGridMonth: {
            dayMaxEventRows: 4
          },
          timeGridWeek: {
            allDayText: this.$t("dashboard.calendar.allDay")
          },
          timeGridDay: {
            allDayText: this.$t("dashboard.calendar.allDay")
          }
        }
      };
    },
    locale() {
      return this.$root.$i18n.locale.replace("-CA", "");
    }
  }),
  async mounted() {
    var _context;
    await this.LOAD_SYNCED_EMAILS();
    this.loading = false;
    if (_includesInstanceProperty(_context = window.location.href).call(_context, "code=")) {
      await this.$nextTick();
      await this.initiateNylas(true, null);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_SYNCED_EMAILS, REFRESH_TOKEN_NYLAS, UPDATE_REFRESH_TOKEN])), {}, {
    async getEventData(dateInfo) {
      if (!this.fetchedDate) {
        this.fetchedDate = moment().format("YYYY-MM-DD");
        await this.updateEvents();
      }
      const currentDate = moment(dateInfo.start).add(1, "months");
      const diff = moment(this.fetchedDate).diff(currentDate, "months");
      if (diff < -2 || diff > 2) {
        this.fetchedDate = moment(currentDate).format("YYYY-MM-DD");
        await this.updateEvents();
      }
      return this.fetchedEvents;
    },
    async updateEvents() {
      this.refreshingEvents = true;
      const {
        emailConnected,
        events
      } = await getCalendarEvents(this.fetchedDate);
      this.emailConnected = emailConnected;
      this.fetchedEvents = events;
      this.refreshingEvents = false;
    },
    async triggerPopover(eventClickInfo) {
      this.$refs.calendarPopover.hide();
      await this.$nextTick();
      this.loadingCalendarEvent = true;
      this.eventObj = eventClickInfo;
      await this.$nextTick();
      this.$refs.calendarPopover.show();
      const {
        eventId
      } = eventClickInfo.event.extendedProps;
      try {
        var _context2;
        const event = _findInstanceProperty(_context2 = this.fetchedEvents).call(_context2, event => event.eventId == eventId);
        await new _Promise(resolve => setTimeout(resolve, 1000));
        this.eventInfo = {
          emailConnected: this.emailConnected,
          events: [event]
        };
      } catch (e) {
        this.$refs.calendarPopover.hide();
        this.eventObj = {};
        Err.handle(e);
      } finally {
        this.loadingCalendarEvent = false;
      }
    },
    handleHidden() {
      this.showCalendarPopover = false;
    },
    transformEvent(rawEvent) {
      const {
          title,
          recurrence = [],
          when
        } = rawEvent,
        extra = _objectWithoutProperties(rawEvent, _excluded);
      const rruleStr = recurrence[0] || "";
      const isRecurrent = rruleStr.length > 0;
      const eventDate = this.getEventTimesFrom(when);
      const parsedEvent = _objectSpread({
        title,
        start: eventDate.start,
        // start and end as string date (UTC)
        end: eventDate.end
      }, extra);
      if (isRecurrent) {
        const rruleStart = this.getRruleStartTime(when);
        parsedEvent.rrule = `${rruleStr};DTSTART=${rruleStart}`;
        parsedEvent.duration = this.getDurationFromDates(eventDate);
      }
      const isLongDay = this.isLongDay(eventDate.start, eventDate.end, isRecurrent);
      // lets add a class if the event should be rendered as a long block
      parsedEvent.className = `clickable ${isLongDay ? "long-day" : ""}`;
      parsedEvent.allDay = this.isAllDay(rawEvent);
      return parsedEvent;
    },
    getRruleStartTime(when) {
      var _when$start_time, _when$start_date;
      const NO_TZ_FORMAT = "YYYYMMDDTHHmmss";
      const {
        object
      } = when;
      let momentStart;
      switch (object) {
        case "time":
          momentStart = moment.unix(when.time).tz(this.userTimezone);
          break;
        case "timespan":
          momentStart = moment.unix((_when$start_time = when.start_time) != null ? _when$start_time : when.startTime).tz(this.userTimezone);
          break;
        case "date":
          momentStart = moment(when.date, "YYYY-MM-DD").startOf("day");
          break;
        case "datespan":
          momentStart = moment((_when$start_date = when.start_date) != null ? _when$start_date : when.startDate, "YYYY-MM-DD").startOf("day");
          break;
      }
      return momentStart.format(NO_TZ_FORMAT) + "Z";
    },
    getEventTimesFrom(when) {
      var _when$start_time2, _when$end_time, _when$start_date2, _when$end_date;
      const NO_TZ_FORMAT = "YYYY-MM-DDTHH:mm:ss";
      const {
        object
      } = when;
      const dates = {
        start: "",
        end: "",
        isEpoch: false
      };
      switch (object) {
        case "time":
          dates.start = moment.unix(when.time).tz(this.userTimezone).format(NO_TZ_FORMAT);
          dates.isEpoch = true;
          break;
        case "timespan":
          dates.start = moment.unix((_when$start_time2 = when.start_time) != null ? _when$start_time2 : when.startTime).tz(this.userTimezone).format(NO_TZ_FORMAT);
          dates.end = moment.unix((_when$end_time = when.end_time) != null ? _when$end_time : when.endTime).tz(this.userTimezone).format(NO_TZ_FORMAT);
          break;
        case "date":
          dates.start = moment(when.date, "YYYY-MM-DD").format(NO_TZ_FORMAT);
          break;
        case "datespan":
          dates.start = moment((_when$start_date2 = when.start_date) != null ? _when$start_date2 : when.startDate, "YYYY-MM-DD").format(NO_TZ_FORMAT);
          dates.end = moment((_when$end_date = when.end_date) != null ? _when$end_date : when.endDate, "YYYY-MM-DD").format(NO_TZ_FORMAT);
          break;
      }
      return dates;
    },
    getDurationFromDates({
      start,
      end
    }) {
      return moment.duration(moment(end).diff(moment(start))).asMilliseconds();
    },
    isLongDay(start, end, isRecurrent) {
      const momentStart = moment(start);
      const momentEnd = moment(end);
      return isRecurrent ? moment.duration(momentEnd.diff(momentStart)).asHours() > 24 : !momentStart.isSame(momentEnd, "day");
    },
    isAllDay({
      when: {
        object
      }
    }) {
      return object === "datespan" || object === "date" || object === "time";
    },
    goToSettings() {
      window.location = "#/personal-settings/account/email-preferences";
    },
    meetingClick() {
      if (!this.syncedEmail.allIds.length) {
        return;
      }
      if (this.syncedEmail.allIds.length === 1) {
        this.initiateNylas(false, this.syncedEmail.allIds[0]);
        return;
      }
      this.$refs.meetingModal.show();
    },
    async initiateNylas(redirect = false, nylasAccountId = null) {
      this.refreshingEvents = true;
      const identity = require("./nylas-scripts/nylas-identity.es.js");
      const requestWrapper = require("./nylas-scripts/request-wrapper.js");
      const config = {
        clientId: NYLAS_CLIENT_ID,
        redirectUri: `${window.location.origin}/nylas-scheduler`,
        domain: "https://api.us.nylas.com/v3",
        hosted: true,
        accessType: "offline"
      };
      const session = await (async () => new identity.NylasSessions(config))();
      const nylasApiRequest = await (async () => new requestWrapper.NylasIdentityRequestWrapper(session))();
      let grantString = localStorage.getItem("grant");
      if (nylasAccountId && grantString) {
        const grant = JSON.parse(grantString);
        if (nylasAccountId != grant.grant_id) {
          localStorage.removeItem("grant");
          localStorage.removeItem("user");
          grantString = null;
        }
      }
      if (redirect) {
        const grant = await this.waitForLocalStorageKey("grant");
        if (grant) {
          const {
            grant_id: grantId,
            refresh_token: refreshToken
          } = JSON.parse(grant);
          if (refreshToken) {
            this.UPDATE_REFRESH_TOKEN({
              grantId,
              refreshToken
            });
          }
        }
      } else {
        if (!grantString) {
          await this.REFRESH_TOKEN_NYLAS({
            grantId: nylasAccountId
          });
        }
      }
      this.openNylasModal(nylasApiRequest);
      this.refreshingEvents = false;
    },
    openNylasModal(nylasApiRequest) {
      var _document$querySelect;
      (_document$querySelect = document.querySelector("nylas-scheduler-editor")) == null ? void 0 : _document$querySelect.remove();
      const schedulerModal = document.querySelector("#scheduler-modal");
      const schedulerEditorScript = require("./nylas-scripts/nylas-scheduler-editor.es.js");
      schedulerEditorScript.defineCustomElement();
      const schedulerEditor = document.createElement("nylas-scheduler-editor");
      const pageStyles = "<div slot='custom-page-style-inputs'><label>Company logo URL</label><input-image-url name='company_logo_url'></input-image-url><label>Primary color</label><input-color-picker name='color'></input-color-picker><label>Submit button label</label><input-component name='submit_button_label' type='text'></input-component><label>Thank you message</label><textarea-component name='thank_you_message' placeholder='You`ll receive an email confirmation soon.'></textarea-component></div>";
      schedulerEditor.insertAdjacentHTML("afterbegin", pageStyles);
      schedulerEditor.nylasApiRequest = nylasApiRequest;
      schedulerEditor.schedulerPreviewLink = `https://book.nylas.com/us/${NYLAS_CLIENT_ID}/{slug}`;
      schedulerEditor.requiresSlug = true;
      schedulerEditor.eventOverrides = {
        schedulerConfigCloseClicked: async e => {
          var _document$querySelect2;
          (_document$querySelect2 = document.querySelector("nylas-scheduler-editor")) == null ? void 0 : _document$querySelect2.remove();
          this.shouldDisplayScheduler = false;
          e.preventDefault();
        }
      };
      schedulerEditor.defaultSchedulerConfigState = {
        selectedConfiguration: {
          requires_session_auth: false,
          // Creates a public Configuration.
          scheduler: {
            rescheduling_url: "https://book.nylas.com/us/reschedule/:booking_ref",
            cancellation_url: "https://book.nylas.com/us/cancel/:booking_ref"
          }
        }
      };
      schedulerModal.appendChild(schedulerEditor);
      this.shouldDisplayScheduler = true;
    },
    waitForLocalStorageKey(key, checkInterval = 500) {
      return new _Promise(resolve => {
        const interval = setInterval(() => {
          if (localStorage.getItem(key) !== null) {
            clearInterval(interval);
            resolve(localStorage.getItem(key));
          }
        }, checkInterval);
      });
    }
  })
});